<template>
    <div class="booking-action-btns">
        <v-row v-if="showSaveWithoutDetails" class="align-end">
            <v-col :cols="canSaveWithoutDetails && !isMobile ? 6 : 12">
                <v-btn
                    :loading="isLoading && !isSavingWithoutDetails"
                    :disabled="isLoading || pageLock"
                    color="primary"
                    block
                    variant="flat"
                    class="main-booking-button"
                    @click="prepareBook"
                >
                    {{ nextStepLabel }}
                </v-btn>
            </v-col>
            <v-col v-if="canSaveWithoutDetails" :cols="!isMobile ? 6 : 12">
                <template v-if="showSaveButtonTooltip">
                    <v-tooltip activator="#save-method-book-button" location="top">
                        {{ $t('booking_page_save_btns_tooltip') }}
                    </v-tooltip>
                </template>
                <v-btn
                    id="save-method-book-button"
                    :disabled="isLoading || pageLock"
                    :loading="isLoading && isSavingWithoutDetails"
                    :variant="isSaveMethodButtonTextStyle ? 'text' : 'flat'"
                    color="primary"
                    block
                    class="save-method-book-button"
                    @click="saveWithoutDetails"
                >
                    <v-icon v-if="showSaveButtonTooltip" class="text-primary d-flex ml-auto mb-2">
                        mdi-information
                    </v-icon>
                    <v-icon v-else>mdi-basket-fill</v-icon>
                    {{ saveMethod.name }}
                </v-btn>
                <div v-if="showSaveButtonTooltip && $breakpoint.smAndDown" class="text-body-2 text-center mt-2">
                    {{ $t('booking_page_save_btns_tooltip') }}
                </div>
            </v-col>
        </v-row>
        <v-row v-if="showNotWithoutDetails" dense>
            <v-col v-if="canPay" :cols="saveMethod && !$breakpoint.smAndDown ? 6 : 12">
                <v-btn
                    :loading="!isPackageBooking && isLoading"
                    :disabled="isLoading || !paymentMethodId || pageLock || !isAgreementsConfirmed"
                    block
                    variant="flat"
                    color="primary"
                    class="main-booking-button"
                    @click="book"
                >
                    <div v-if="isPackageBooking && isLoading" class="d-flex gc-2 align-center">
                        <v-progress-circular size="20" indeterminate width="2" />
                        <span class="text-wrap">{{ $t('booking_waiting_message') }}</span>
                    </div>
                    <span v-else>{{ $t('booking_book') }}</span>
                </v-btn>
            </v-col>
            <v-col v-if="saveMethod" cols="12" md="6">
                <template v-if="showSaveButtonTooltip">
                    <v-tooltip activator="#save-method-book-button" location="top">
                        {{ $t('booking_page_save_btns_tooltip') }}
                    </v-tooltip>
                </template>
                <v-btn
                    id="save-method-book-button"
                    :disabled="isLoading || pageLock || !isAgreementsConfirmed || dueToConfirmDateActive"
                    :variant="isSaveMethodButtonTextStyle ? 'text' : 'flat'"
                    color="primary"
                    block
                    class="save-method-book-button"
                    @click="save"
                >
                    <v-icon v-if="showSaveButtonTooltip" class="text-primary d-flex ml-auto mb-2">
                        mdi-information
                    </v-icon>
                    <v-icon v-else>mdi-basket-fill</v-icon>
                    {{ saveMethod.name }}
                </v-btn>
                <div v-if="showSaveButtonTooltip && $breakpoint.smAndDown" class="text-body-2 text-center mt-2">
                    {{ $t('booking_page_save_btns_tooltip') }}
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue, Inject} from 'vue-facing-decorator'

    @Component
    export class BookingActionBtns extends Vue {
        @Prop() bookingKey
        @Prop() basketKey
        @Prop() saveMethod
        @Prop() paymentMethodId
        @Prop({type: String}) nextStepLabel
        @Prop({default: false, type: Boolean}) isSavingWithoutDetails
        @Prop({default: false, type: Boolean}) canSaveWithoutDetails
        @Prop({default: false, type: Boolean}) isMobile
        @Prop({default: false, type: Boolean}) isLoading
        @Prop({default: false, type: Boolean}) pageLock
        @Prop({default: false, type: Boolean}) isSaveMethodButtonTextStyle
        @Prop({default: false, type: Boolean}) canPay
        @Prop({default: false, type: Boolean}) isAgreementsConfirmed
        @Prop({default: false, type: Boolean}) dueToConfirmDateActive

        @Inject({default: false}) isPackageBooking

        @Emit()
        prepareBook() {}

        @Emit()
        saveWithoutDetails() {}

        @Emit()
        book() {}

        @Emit()
        save() {}

        get showSaveWithoutDetails() {
            return (!this.bookingKey && !this.basketKey) || this.isSavingWithoutDetails
        }

        get showNotWithoutDetails() {
            return (this.bookingKey || this.basketKey) && !this.isSavingWithoutDetails
        }

        get showSaveButtonTooltip() {
            return false
        }
    }

    export default BookingActionBtns
</script>
